import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
        Typography} from "@mui/material";

import {Grey6} from "../../theme/styles";
import PasswordField from "../Common/PasswordField";

// Signing one slot.
//
// SHARED BY THE QUEUE AND THE RECORD'S APPROVAL TAB, deliberately. What a signature MEANS is the
// part Part 11 cares about, and two implementations of that wording would drift -- one of them
// would end up saying less than the other, and which one a person saw would depend on where they
// happened to click.
//
// Four things a save dialog does not do:
//   * states the meaning AS A SENTENCE, not a field label -- somebody who cannot say what they
//     attested to has not really attested;
//   * names what is being signed, because the signature binds a content hash;
//   * requires a comment to reject;
//   * says plainly that it is final. A signature is superseded, never edited or deleted, and there
//     is no undo anywhere in this design.

export default function ApprovalSignatureDialog({open, request, slot, busy, onSign, onClose}: any) {
    const [comment, setComment] = useState("");
    // NEVER PUT ANYWHERE BUT THIS REQUEST. Held in component state for the length of the dialog,
    // cleared when it opens and when it closes, and sent straight to the signing call. Not stored,
    // not logged, not carried in the URL.
    const [password, setPassword] = useState("");

    React.useEffect(() => { if (open) { setComment(""); setPassword(""); } }, [open, slot?.USID]);

    return (
        <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{fontSize: 16}}>Sign</DialogTitle>
            <DialogContent>
                <Typography style={{fontSize: 14, marginBottom: 10}}>
                    You are signing as <strong>{slot?.Meaning}</strong>
                    {slot?.Label ? ` — ${slot.Label}` : ""}, for{" "}
                    <strong>{request?.RecordName}</strong> revision {request?.RecordRevision}
                    {slot?.PersonaName ? `, as ${slot.PersonaName}` : ""}.
                </Typography>
                <Typography style={{fontSize: 12, color: Grey6, marginBottom: 14}}>
                    This is final. A signature is superseded, never edited or deleted.
                </Typography>
                <TextField label="Comment" fullWidth multiline minRows={2} size="small"
                           value={comment} onChange={event => setComment(event.target.value)}
                           helperText="Required when rejecting."/>
                {/* 21 CFR 11.200(a)(1): a signature uses two identification components and asks for
                    both at each signing. Being logged in proves who started the session, not who is
                    at the keyboard now -- which is the whole difference between a signature and a
                    click. autoComplete="off" so a browser does not helpfully fill it in and undo
                    the point of asking. */}
                <PasswordField label="Your password" fullWidth size="small"
                           sx={{mt: 2}} autoComplete="off"
                           value={password} onChange={event => setPassword(event.target.value)}
                           helperText="Confirms this signature is yours."/>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={busy} sx={{textTransform: "none"}}>Cancel</Button>
                <Button onClick={() => onSign("REJECT", comment, password)}
                        disabled={busy || !comment.trim() || !password}
                        color="error" sx={{textTransform: "none"}}>Reject</Button>
                <Button onClick={() => onSign("APPROVE", comment, password)}
                        disabled={busy || !password} variant="contained"
                        sx={{textTransform: "none"}}>Approve</Button>
            </DialogActions>
        </Dialog>
    );
}
